var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#06030F",
  d: "m17.317 10.613-5.625 5.625a.625.625 0 1 1-.884-.884l4.558-4.558H3.125a.625.625 0 1 1 0-1.25h12.241l-4.558-4.558a.625.625 0 1 1 .884-.884l5.625 5.625a.626.626 0 0 1 0 .884"
})));
export default SvgArrowRightBlack;